"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _component = require("../component");

var _styles = require("../styles");

var _context = _interopRequireDefault(require("./context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Item =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Item, _PureComponent);

  function Item(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.check = _this.check.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Item.prototype;

  _proto.check = function check(c) {
    var _this$props = this.props,
        index = _this$props.index,
        selecteds = _this$props.selecteds,
        checkKey = _this$props.checkKey,
        setSelecteds = _this$props.setSelecteds;

    if (c) {
      setSelecteds(index, [].concat(selecteds[index], [checkKey]));
    } else {
      setSelecteds(index, selecteds[index].filter(function (ch) {
        return ch !== checkKey;
      }));
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        content = _this$props2.content,
        selecteds = _this$props2.selecteds,
        checkKey = _this$props2.checkKey,
        index = _this$props2.index,
        disabled = _this$props2.disabled,
        itemClass = _this$props2.itemClass;
    return _react.default.createElement("div", {
      className: (0, _classnames.default)((0, _styles.transferClass)('item', disabled && 'item-disabled'), itemClass)
    }, _react.default.createElement(_Checkbox.default, {
      className: (0, _styles.transferClass)('item-check'),
      onChange: this.check,
      disabled: disabled,
      checked: selecteds[index].indexOf(checkKey) > -1
    }, content));
  };

  return Item;
}(_component.PureComponent);

Item.propTypes = {
  index: _propTypes.default.number,
  selecteds: _propTypes.default.array,
  checkKey: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  setSelecteds: _propTypes.default.func,
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  disabled: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  itemClass: _propTypes.default.string
};

var _default = function _default(prop) {
  return _react.default.createElement(_context.default.Consumer, null, function (value) {
    return _react.default.createElement(Item, _extends({}, prop, {
      selecteds: value.selecteds,
      setSelecteds: value.setSelecteds
    }));
  });
};

exports.default = _default;